import https from '../../init/https';

//BOOK-01 : Check real time availability of the solts
export async function tripAvaFun(data) {
    const result = await https.post(`/booking/trip/check-availability`, data);
    return result;
}

//BOOK-13 : Trip reserve for guest
export async function tripReserveGuestFun(data) {
    const result = await https.post(`/booking/trip/reserve/guest`, data);
    return result;
}

//BOOK-15 - Create orderId for razor pay
export async function createOrderId(data) {
    const result = await https.post(`/booking/order/id`, data);
    return result;
}

//BOOK-18 : Booking status check
export async function bookingStatus(type, id) {
    const result = await https.get(`/booking/check/payment/status/booking/${type}/${id}`);
    return result;
}
